import DashboardPage from '@components/pages/dashboard'
import AccountDetails from '@routes/settings/routes/account/accountDetails'
import AccountTerms from '@routes/settings/routes/account/accountTerms'
import MfaSettings from '@routes/settings/routes/account/mfaSettings'
import { AccountPageWrapper } from './settings.account.route.styles'

const AccountPage = () => (
    <DashboardPage name="settings-account">
        <AccountPageWrapper>
            <AccountDetails />
            <MfaSettings />
            <AccountTerms />
        </AccountPageWrapper>
    </DashboardPage>
)

export default AccountPage
